<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" id="apt1" title="BREAKFAST">
<p class="h2c"><span class="right_1" epub:type="pagebreak" id="page_12" title="12"><a href="#/text/Contents#pt1">BREAKFAST</a></span></p>
<p class="noindentj">Breakfast is the meal of the day with the most options going for it. Do you want to start your day with something sweet? Something salty? Light? Heavy? It’s the most important meal of the day and no one will look at you twice if you make that meal cake—so long as those are <i>pan</i>cakes, that is. And let’s not forget waffles and muffins, both essentially desserts. But before you get overloaded with thoughts of starting every day on a sugar high, contained in this chapter are also recipes for carrot lox, bacon, quiche, and many more savory breakfast goodies. Thank goodness for breakfast!</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part001.vue?eeabb38c